"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
/**
 * Language switch
 */
var LanguageSwitch = /** @class */ (function (_super) {
    __extends(LanguageSwitch, _super);
    function LanguageSwitch() {
        var _this = _super.call(this, constants_1.DATA_LANGUAGE_SWITCH) || this;
        _this.initLangSelect = function () {
            _this.hideAllLanguageOptions();
            var langValue = '';
            _this.languageSwitchSelect.childNodes.forEach(function (element) {
                var elementUrl = element.getAttribute('data-red-url');
                if (elementUrl === _this.getElement().getAttribute('data-active-url')) {
                    langValue = element.value;
                    var countryVersion_1 = element.getAttribute('data-countries');
                    _this.countrySwitchSelect.childNodes.forEach(function (cElement) {
                        if (cElement.value === countryVersion_1) {
                            cElement.setAttribute('selected', '');
                        }
                        else {
                            cElement.removeAttribute('selected');
                        }
                    });
                    _this.countrySwitchSelect.dispatchEvent(new Event('change'));
                }
            });
            _this.languageSwitchSelect.childNodes.forEach(function (element) {
                if (element.value === langValue) {
                    element.setAttribute('selected', '');
                }
                else {
                    element.removeAttribute('selected');
                }
            });
            _this.languageSwitchSelect.dispatchEvent(new Event('change'));
        };
        _this.initEvents = function () {
            _this.countrySwitchSelect.addEventListener('change', _this.cChange);
            _this.languageSwitchSelect.addEventListener('change', _this.lChange);
            _this.getElement().addEventListener('submit', _this.submit);
        };
        _this.submit = function (e) {
            e.preventDefault();
            window.location.href = _this.languageSwitchSelect.querySelector('[selected]').getAttribute('data-red-url');
        };
        _this.cChange = function (e) {
            _this.hideAllLanguageOptions();
            var countryVersion = e.target.value;
            _this.showLanguageOptions(countryVersion);
        };
        _this.lChange = function (e) {
            var languageUid = e.target.value;
            _this.languageSwitchSelect.childNodes.forEach(function (element) { return element.style.display === 'block' && element.value === languageUid ? element.setAttribute('selected', '') : element.removeAttribute('selected'); });
        };
        _this.showLanguageOptions = function (countryVersion) {
            var options = _this.languageSwitchSelect.querySelectorAll("[data-countries=\"".concat(countryVersion, "\"]"));
            options.forEach(function (option, index) {
                option.style.display = 'block';
                if (index === 0) {
                    option.setAttribute('selected', '');
                }
            });
            if (options.length > 1) {
                _this.languageSwitchSelect.removeAttribute('disabled');
            }
            else {
                _this.languageSwitchSelect.setAttribute('disabled', '');
            }
        };
        _this.hideAllLanguageOptions = function () { return _this.languageSwitchSelect.querySelectorAll('option').forEach(function (option) {
            option.style.display = 'none';
            option.removeAttribute('selected');
        }); };
        if (!_this.getElement())
            return _this;
        _this.languageSwitchSelect = _this.getElement().querySelector("[".concat(constants_1.DATA_LANGUAGE_SWITCH_SELECT, "]"));
        _this.countrySwitchSelect = _this.getElement().querySelector("[".concat(constants_1.DATA_COUNTRY_SWITCH_SELECT, "]"));
        // get options on page load for "global" selection
        _this.initEvents();
        _this.initLangSelect();
        return _this;
    }
    return LanguageSwitch;
}(AbstractComponent_1.default));
exports.default = LanguageSwitch;
